import type { Dayjs } from 'dayjs';

import type { QuestionTypeType } from '@shared/services/appointment/form/types/appointmentForm.type';
import type { GetAppointmentListPayload } from '@shared/services/appointment/getLists/types/getAppointmentList.type';
import type { EnableWhen } from '@shared/types/form.types';

export interface QuestionnaireItem {
  AdditionalItem?: null | QuestionnaireItem[];
  AdditionalQuestionKey: number;
  Answer?: boolean | Dayjs | null | number | string;
  AnswerOption?: string[];
  Category?: string;
  CurrentAnswer?: null | string;
  CurrentNumberOfAddButton: number;
  DependencyQuestions?: QuestionnaireItem[];
  EnableBehavior?: null | string;
  EnableWhen?: EnableWhen | null;
  GroupItem?: QuestionnaireItem[];
  HelperItem?: Helper;
  IsDropDown?: boolean | null;
  IsHorizontal?: boolean;
  IsRootGroup?: boolean;
  LinkId: string;
  MaxNumberOfAddButton: number;
  Repeats?: boolean | null;
  Required?: boolean | null;
  Text: string;
  Type: QuestionTypeType;
  Validations?: null | QuestionnaireValidation[];
}

export const ValidationsKeys = {
  AdditionalPhoneNumber: 'is-singapore-additional-phone-number',
  Age: 'is-valid-age',
  Email: 'is-valid-email',
  Height: 'is-valid-height',
  HeightInMetre: 'is-valid-height-in-metre',
  MaxTwoDigitals: 'max-2-digits',
  Nric: 'is-nric',
  PhoneNumber: 'is-singapore-phone-number',
  PostalCode: 'is-valid-postal-code',
  Weight: 'is-valid-weight',
} as const;

export type FormAnswerQuestion = Record<string, boolean | Dayjs | number | string>;

export interface GetQuestionnairePayload extends GetAppointmentListPayload {
  AppointmentId?: string;
  QuestionnaireId: string;
  VisitNumber?: string;
}

export interface Helper {
  LinkId: null | string;
  Text: null | string;
  Type: null | string;
}

export interface QuestionnaireResult {
  CurrentProcessQuestionnaireId: null | string;
  Description: string;
  Id: string;
  InProgressQuestionId?: string;
  InstitutionName?: string;
  Item: QuestionnaireItem[];
  Logo?: string;
  QuestionnaireStatus: null | string;
  Title: string;
  Version: string;
}

export interface QuestionnaireValidation {
  Expression: string;
  Key: ValidationsKeysType;
  Message: string;
  Type: string;
}

export interface ReviewQuestionnaires {
  reviewQuestions: QuestionnaireItem[];
  title: string;
}

type ValidationsKeysType = (typeof ValidationsKeys)[keyof typeof ValidationsKeys];
